export default __webpack_public_path__ + "static/media/Map.e082f20a.svg";